module.exports = __webpack_public_path__ + "img/18-PROSAPresent.067862ac.jpg";